import { IWorksheetComponent } from 'Components/Worksheets/Core';

/**
 * The volume determination method
 */
export enum VolumeDeterminationMethod {
  BulkDensity = 'BulkDensity',
  DirectEntry = 'DirectEntry',
}

export interface IEmbeddedTestProps extends IWorksheetComponent {
  isEmbeddedTest?: boolean;
}
